const decodeJwtPayload = (jwt: string): Record<string, unknown> | null => {
  const payload = jwt.split(".")[1];
  if (!payload) {
    return null;
  }

  try {
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
};

/**
 * Decodes a JWT payload's `exp` claim. No signature verification — the client
 * only needs the expiry to size the token cookie; the server stays the
 * authority on validity.
 */
export const getJwtExpiry = (jwt: string): Date | null => {
  const exp = decodeJwtPayload(jwt)?.exp;

  return typeof exp === "number" ? new Date(exp * 1000) : null;
};

/**
 * Decodes a JWT payload's `tenant_name` claim — the tenant the participant is
 * authenticated against. No signature verification; the server stays the
 * authority. Returns null when the token is malformed or the claim is absent.
 */
export const getJwtTenantName = (jwt: string): string | null => {
  const tenantName = decodeJwtPayload(jwt)?.tenant_name;

  return typeof tenantName === "string" ? tenantName : null;
};
